<template>
  <el-col id="day-count" :span="4">
    <img src="@/assets/img/black_truck.svg" />

    <el-tooltip content="Подтвержденные отклики" placement="top" effect="light">
      <span class="approve">
        {{ day.responses_count_approved }}
      </span>
    </el-tooltip>
    /
    <el-tooltip content="Неподтвержденные отклики" placement="top" effect="light">
      <span class="not-served">
        {{ day.responses_count_not_served }}
      </span>
    </el-tooltip>
    /
    <el-tooltip content="Заявки на отклики" placement="top" effect="light">
      <span class="request">
        {{ day.response_requests_count }}
      </span>
    </el-tooltip>
  </el-col>
</template>

<script>
export default {
  name: 'DayCount',
  props: {
    day: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="sass">
#day-count
  display: flex
  align-items: center
  justify-content: center
  .approve
    margin-left: 10px
    color: #4C9429
  .not-served
    color: #409EFF
  .request
    color: #AAA8AB
.el-tooltip__popper.is-light
  padding: 5px 10px
  color: #303133
</style>
